<template>
    <div class="border-bottom sticky-top">
        <mobile-nav v-if="model.isMobile"></mobile-nav>
        <desktop-nav v-else></desktop-nav>
    </div>
</template>

<script>
    import MobileNav from "./MobileNav.vue";
    import DesktopNav from "./DesktopNav.vue";

    export default {
        name: 'NavBar',
        components: {DesktopNav, MobileNav},
        data() {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
